/**
 * Download click counter (Abacus, free key-value counter API).
 * Uses the exact same namespace and key set as the CooperScene project
 * page (static/js/main.js), so a download from either site increments
 * the same shared counters:
 *   - 'mini-set'     Mini Set / curated quick-start subset
 *   - 'full-dataset' Full dataset (any split, or a per-scene chunk of one)
 *   - 'mcap'         Foxglove-ready MCAP recordings
 */

const COUNTER_API = 'https://abacus.jasoncameron.dev';
const COUNTER_NAMESPACE = 'ucr-cisl-cooperscene';

// Running counts and the total display element, if this page has one
// (only the landing page's Downloads section does). Module-level so
// countDownload() can refresh the visible total right after a click,
// not just on the initial page-load fetch.
const counts = {};
let totalEl = null;

function renderTotal() {
  if (!totalEl) return;
  const values = Object.values(counts);
  if (values.length === 0) return;
  const total = values.reduce((sum, n) => sum + n, 0);
  totalEl.textContent = `${total.toLocaleString()} ${total === 1 ? 'download' : 'downloads'}`;
}

/** Register a click against a shared counter (best-effort, never blocks). */
export function countDownload(key) {
  fetch(`${COUNTER_API}/hit/${COUNTER_NAMESPACE}/download-${key}`, {
    keepalive: true
  })
    .then((res) => res.json())
    .then((data) => {
      counts[key] = typeof data.value === 'number' ? data.value : (counts[key] || 0) + 1;
      renderTotal();
    })
    .catch(() => { /* counting is best-effort */ });
}

/**
 * Fetch the current sum across the given keys and render it into `el`
 * (matching CooperScene's "X downloads" total wording). `countDownload`
 * calls from this point on will keep it updated as clicks come in.
 */
export function renderDownloadTotal(el, keys) {
  totalEl = el;
  if (!el || keys.length === 0) return;

  for (const key of keys) {
    fetch(`${COUNTER_API}/get/${COUNTER_NAMESPACE}/download-${key}`)
      .then((res) => res.json())
      .then((data) => {
        counts[key] = typeof data.value === 'number' ? data.value : (counts[key] || 0);
        renderTotal();
      })
      .catch(() => { /* counting is best-effort; leave the total as-is */ });
  }
}
